/* Atlas rail arrows: the round prev / next arrows over any sideways product row, the same as the homepage New in row.
   Put data-arrows on the scrolling row (data-arrows="sm" for smaller arrows) and load this file. The arrows go in the
   row's parent, level with the middle of the first photo, and hide at either end and when nothing overflows. Each
   click moves by the cards in view. Phones and touch screens swipe instead, so the arrows only show with a mouse. */
(function () {
  if (window.__atlasRailArrows) return;
  window.__atlasRailArrows = true;

  var ICON = {
    prev: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    next: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
  };

  var css = document.createElement('style');
  css.textContent =
    '.arail__btn{position:absolute;z-index:4;top:0;width:44px;height:44px;margin:0;padding:0;border-radius:50%;background:#FFFFFF;border:1px solid #E5E5E5;color:#141413;display:flex;align-items:center;justify-content:center;cursor:pointer;min-height:0;box-shadow:0 4px 16px rgba(20,20,19,.10);transform:translateY(-50%);transition:opacity .2s ease,background .2s ease,color .2s ease,border-color .2s ease;}' +
    '.arail__btn:hover{background:#141413;color:#FFFFFF;border-color:#141413;}' +
    '.arail__btn.is-off{opacity:0;pointer-events:none;}' +
    '.arail__btn--sm{width:36px;height:36px;}' +
    '.arail__btn--sm svg{width:15px;height:15px;}' +
    '@media (max-width:749px),(hover:none){.arail__btn{display:none;}}';
  document.head.appendChild(css);

  var rows = [];

  function btns(sc) {
    var p = sc.parentElement;
    return { p: p, prev: p.querySelector(':scope > .arail__btn--prev'), next: p.querySelector(':scope > .arail__btn--next') };
  }

  function make(dir, sm) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'arail__btn arail__btn--' + dir + (sm ? ' arail__btn--sm' : '');
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    b.innerHTML = ICON[dir];
    return b;
  }

  function setup(sc) {
    if (sc.__arail) return;
    sc.__arail = true;
    var p = sc.parentElement;
    if (!p) return;
    if (getComputedStyle(p).position === 'static') p.style.position = 'relative';
    var b = btns(sc), sm = sc.getAttribute('data-arrows') === 'sm';
    /* a copied row (the cart page copies the drawer's) can arrive with its arrows already in place */
    if (!b.prev) p.appendChild(make('prev', sm));
    if (!b.next) p.appendChild(make('next', sm));
    sc.addEventListener('scroll', function () { ends(sc); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { place(sc); }).observe(sc);
    rows.push(sc);
    place(sc);
  }

  function ends(sc) {
    var b = btns(sc);
    if (!b.prev || !b.next) return;
    var max = sc.scrollWidth - sc.clientWidth;
    b.prev.classList.toggle('is-off', max <= 4 || sc.scrollLeft <= 4);
    b.next.classList.toggle('is-off', max <= 4 || sc.scrollLeft >= max - 4);
  }

  /* inside the row's visible edges, level with the middle of the first photo */
  function place(sc) {
    var b = btns(sc);
    if (!b.prev || !b.next || !sc.isConnected) return;
    var pr = b.p.getBoundingClientRect(), sr = sc.getBoundingClientRect();
    if (!sr.width) return;
    var inset = sc.getAttribute('data-arrows') === 'sm' ? 6 : 12;
    var media = sc.querySelector('[data-arrows-media], img, picture, video');
    var mid = media && media.getBoundingClientRect().height
      ? media.getBoundingClientRect().top - pr.top + media.getBoundingClientRect().height / 2
      : sr.top - pr.top + sr.height / 2;
    var left = Math.max(sr.left, pr.left) - pr.left + inset;
    var right = pr.right - Math.min(sr.right, pr.right) + inset;
    b.prev.style.top = b.next.style.top = mid + 'px';
    b.prev.style.left = left + 'px';
    b.next.style.right = right + 'px';
    ends(sc);
  }

  /* move by the whole cards in view, so the next card lands where the first one was */
  function by(sc, d) {
    var c = sc.firstElementChild;
    var gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
    var step = c ? c.getBoundingClientRect().width + gap : 300;
    var fit = Math.max(1, Math.floor((sc.clientWidth + gap) / step));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sc.scrollBy({ left: d * step * fit, behavior: reduce ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.arail__btn');
    if (!b) return;
    var sc = b.parentElement.querySelector(':scope > [data-arrows]');
    if (!sc) return;
    e.preventDefault();
    e.stopPropagation();
    by(sc, b.classList.contains('arail__btn--prev') ? -1 : 1);
  });

  function scan() {
    document.querySelectorAll('[data-arrows]').forEach(function (sc) {
      /* re-rendered or copied rows are new elements: set them up again */
      setup(sc);
    });
    rows = rows.filter(function (sc) { return sc.isConnected; });
  }
  function placeAll() { rows.forEach(place); }

  var t = 0;
  function later() { clearTimeout(t); t = setTimeout(scan, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', placeAll);
  window.addEventListener('resize', placeAll);
  document.addEventListener('shopify:section:load', later);
  if ('MutationObserver' in window) new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
